module.exports = __webpack_public_path__ + "img/26.caf22df4.png";